import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ISalesState }          from 'Redux/Slices/Sales/SalesSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findDailySalesRequest = (state: Draft<ISalesState>, { type }: PayloadAction) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findDailySalesSuccess = (state: Draft<ISalesState>, { type, payload }: PayloadAction<{
  days: {
    ymd: string,
    count: number,
    total: string,
    netto: string,
    status: string
  }[]
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, days: payload.days };
};

export const findDailySalesFailure = (state: Draft<ISalesState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
